import Stack from './StackClient';

export default Stack;
